import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';


// Suprimir ResizeObserver loop undelivered notifications (avís benigne del navegador al redimensionar)
// i errors de xarxa en carregar el worker secundari de Monaco des del CDN de jsDelivr
const isIgnorableError = (msg: any) => {
  const str = String(msg || '');
  return str.includes('ResizeObserver loop completed with undelivered notifications') ||
         str.includes('ResizeObserver loop limit exceeded') ||
         str.includes('workerMain.js') ||
         (str.includes('importScripts') && str.includes('WorkerGlobalScope'));
};

const prevOnError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (isIgnorableError(message) || (error && isIgnorableError(error.message))) {
    return true;
  }
  if (prevOnError) {
    return prevOnError(message, source, lineno, colno, error);
  }
  return false;
};

window.addEventListener('error', (e) => {
  if (isIgnorableError(e.message) || isIgnorableError(e.error?.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

window.addEventListener('unhandledrejection', (e) => {
  const reasonMsg = e.reason ? (e.reason.message || String(e.reason)) : '';
  if (isIgnorableError(reasonMsg)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

const originalFetch = window.fetch;
window.fetch = async (input, init) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    init = init || {};
    init.headers = init.headers || {};
    if (init.headers instanceof Headers) {
      init.headers.append('Authorization', `Bearer ${token}`);
    } else if (Array.isArray(init.headers)) {
      init.headers.push(['Authorization', `Bearer ${token}`]);
    } else {
      (init.headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
    }
  }
  return originalFetch(input, init);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || "263998953995-lj8b0d0q5boof4j70jrtlch4rvjtulqi.apps.googleusercontent.com"}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
